export enum TIMERECORDING_VALIDITY {
    VALID = 'valid',
    INVALID_NUMBER_OF_ROWS = 'timerecording-invalidnumberofrows',
    INVALID_ORDER = 'timerecording-invalidorder',
    GAP_DETECTED = 'timerecording-gapdetected',
    PHONEFIX_TOO_MANY_ROWS = 'timerecording-phonefixtoomanyrows',
    ENDTIME_BEFORE_STARTTIME = 'timerecording-endtimebeforestarttime',
    INVALID_FUTURE_START_TIME = 'timerecording-invalidfuturestarttime',
}
